//Module Keys
let locales = {};

//Merge Views
import tab from 'Modules/rawData/.components/tab/lan/en';
import showRawData from 'Modules/rawData/.components/showRawData/lan/en';
import videoPlayer from 'Modules/rawData/.components/videoPlayer/lan/en';

locales = { ...locales, ...tab, ...showRawData, ...videoPlayer };


export default locales;